<template>
  <div>
    <div class="goods-info-table-wrap lib-mt-10">
      <table id="sub-goods-domain" class="table_row_pay pilsu">
        <colgroup><col width="200px;"><col></colgroup>
        <tbody>
        <tr>
          <th>
            <p class="lib-mt-5" style="float:left;"><span>도메인</span></p>
            <div class="position-relative d-inline-block ml-5 notice-info">

              <!-- 도메인 안내 문구 -->
              <v-popover
                  v-if="isFreeDomain"
                  placement="right"
              >
                <a href="javascript:void(0);" class="btn-hw-rwd-layer" title="부가 정보 보기" data-ui="layer-guide" data-target="layer-popover-test">
                  <i class="fas fa-question-circle primary-color"></i>
                </a>

                <template slot="popover">
                  <div class="hw-rwd-layer layer-popover-test" style="width: 720px;">
                    <div class="d-flex flex-column / h-100">
                      <div class="layer-header">도메인 안내
                      </div>
                      <div class="layer-body flex-1">
                        <ul class="list-dot">
                          <li>도메인이 있어야 신청할 수 있습니다.</li>
                          <li>본인 소유의 도메인 / 타인 소유일 경우 소유자의 허락을 얻은 도메인만 신청 가능합니다. 타인 소유의 도메인으로 신청 후 분쟁이 발생하면 불이익을 당할 수 있습니다.</li>
                          <li>한글 도메인은 지원되지 않으므로 신청할 수 없습니다.</li>
                        </ul>
                      </div>
                      <div class="layer-footer">
                        <button type="button" class="layer-close hw-pill-button small" v-close-popover >확인</button>
                      </div>
                    </div>
                  </div>
                </template>
              </v-popover>

              <!-- 무료 2차 도메인 안내 문구 -->
              <v-popover
                  v-else
                  placement="right"
              >
                <a href="javascript:void(0);" class="btn-hw-rwd-layer" title="부가 정보 보기" data-ui="layer-guide" data-target="layer-popover-test">
                  <i class="fas fa-question-circle primary-color"></i>
                </a>

                <template slot="popover">
                  <div class="hw-rwd-layer layer-popover-test" style="width: 720px;">
                    <div class="d-flex flex-column / h-100">
                      <div class="layer-header">오피스 주소 안내</div>
                      <div class="layer-body flex-1">
                        <ul class="list-dot">
                          <li>무료로 제공되는 오피스는 도메인 없이 무료로 제공되는 2차 도메인을 사용하는 오피스이며 2차 도메인 형태로 무료 오피스 주소를 생성하고 오피스를 바로 이용할 수 있습니다.</li>
                          <li>최초 오피스 생성자가 관리자가 되며, 나머지 오피스 구성원의 계정은 관리자가 직접 생성해 줍니다.<br/>
                              (따라서 구성원은 하이웍스에 별도로 가입하지 않아도 됩니다.)</li>
                          <li>접속 주소<br/>
                              https://office.hiworks.com/오피스명.onhiworks.com</li>
                          <li>오피스 회원 계정<br/>
                              id@오피스명.onhiworks.com</li>
                        </ul>
                      </div>
                      <br/>
                      <div>※ 오피스 이용 중 내 도메인으로 연결하려면 서비스 관리 페이지에서 [도메인 연결]을 신청하시면 도메인 연결 오피스 이용이 가능합니다. (도메인 연결 비용 무료)</div>
                      <div class="layer-footer">
                        <button type="button" class="layer-close hw-pill-button small" v-close-popover >확인</button>
                      </div>
                    </div>
                  </div>
                </template>
              </v-popover>


            </div>
          </th>
          <td style="padding: 0px; height: 43px; display: none;">
            <div class="td-loading"></div>
          </td>
          <td>
            <div class="hw-input-wrap" v-if="isFreeDomain">
              <div v-show="!isLoading">
                <input type="text"
                       id="domain-check"
                       placeholder="본인 소유 또는 실제 소유자의 허락을 얻은 도메인만 가능합니다."
                       class="hw-input w-90"
                       v-on:keyup.enter="checkDomain(domain)"
                       v-model="localDomain"
                >
                <button type="button" 
                        class="hw-pill-button text small"
                        @click="checkDomain(domain)">확인</button>
                <div v-show="isPossible && domain">
                  <div v-show="msgFlag==='GABIA_OWNER'">
                    <div>{{localDomain}} - 신청 가능한 도메인입니다. (설치비 20,000원 할인)</div>
                    <div>
                      타인 소유의 도메인은 해당 아이디로 로그인 후, 자동 연결 설정해야 합니다.
                    </div>
                    <a class="hw-pill-button text small" target="_blank" href="https://dns.gabia.com" style="padding-left: 0px !important;">
                      설정 방법 보기
                    </a>
                  </div>
                  <div v-show="msgFlag==='NO_GABIA_OWNER'">
                    <div>{{localDomain}} - 신청 가능한 도메인입니다.</div>
                    <div>
                      타사 등록 도메인은 직접 DNS 정보를 설정해야 합니다.
                      <a class="hw-pill-button text small" target="_blank" href="https://www.hiworks.com/manual#/hiworks/113/1242">설정 방법 보기</a>
                    </div>
                  </div>
                </div>
                <div v-show="!isPossible && domainMsg">
                  {{domainMsg}}
                  <a v-show="msgFlag==='no_register'"
                     class="hw-pill-button text small"
                     href="https://domain.gabia.com/regist/regist_domain">가비아에서 신청하기</a>
                </div>

              </div>
              <div v-show="isLoading" style="text-align: center">
                <img src="https://www.hiworks.com/static/images/sns_img/progress.gif" alt="로딩 중"/>
              </div>
            </div>
            <div class="hw-input-wrap" v-else>

              <div>전자세금계산서 상품은 무료 2차 도메인을 제공합니다.</div>
              <div>결제 완료 후 관리정보 입력 페이지에서 오피스명을 입력하세요.</div>
              <div class="domain-notice">※ 오피스 주소는 https://office.hiworks.com/내오피스명.onhiworks.com 으로 제공됩니다.</div>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from "vuex";

export default {
  name: "DomainCheck",
  props:{
    packageId : {
      type:Number
    }
  },
  data(){
    return {
      localDomain : null,
      isLoading: false,
      msgFlag : null,
      isPossible : false,
    }
  },
  computed:{
    ...mapState({
      domain: state => state['order_info']['domain'],
      domainMsg: state => state['order_info']['domainMsg'],
    }),
    ...mapGetters({
      domainType: 'goods_info/getDomainType',
    }),
    isFreeDomain(){
      return this.domainType === "Y"
    },
  },
  watch: {
    localDomain (localDomain){
      if(this.domain !== localDomain){
        this.setDomainInit()
      }
    }
  },
  methods: {
    ...mapActions({
      storeCheckDomain: 'checkDomain',
      setDomainInit: 'setDomainInit',
    }),
    checkDomain(){
      let domainRegex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/
      
      if(!this.localDomain){
        alert('도메인을 입력해주세요.')
        return
      }
      if(!domainRegex.test(this.localDomain)){
        alert('올바른 도메인 형식이 아닙니다.')
        return
      }

      this.localDomain = this.localDomain.trim()
      
      this.isLoading = true
      this.storeCheckDomain(this.localDomain)
      .then((info)=>{
        this.msgFlag = info.flag
        this.isPossible = info.isPossible
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.domain-notice{
  margin-top: 5px;
  color:red;
}
</style>